<div class="upcoming_news">
  <span class="up_icon"><i class="mdi mdi-bullhorn" aria-hidden="true"></i></span>
  <marquee>{{message}}</marquee>
  <em class="up_datetime">{{todayDate | date:'d MMM y h:mm:ss'}}</em>
</div>